import { render, staticRenderFns } from "./RekapPotensiDesa.vue?vue&type=template&id=3ab130f9&scoped=true"
import script from "./RekapPotensiDesa.vue?vue&type=script&lang=js"
export * from "./RekapPotensiDesa.vue?vue&type=script&lang=js"
import style0 from "./RekapPotensiDesa.vue?vue&type=style&index=0&id=3ab130f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab130f9",
  null
  
)

export default component.exports